// @ts-nocheck

import styled from 'styled-components';

import { NAVBAR_BASE_HEIGHT } from '../constants/ui/navbar';
import { TABBAR_BASE_HEIGHT } from '../constants/ui/tabbar';

export const LayoutMobileStyle = styled.div`
  *:not(input) {
    user-select: none;
  }

  &.opened {
    overflow: hidden;
    touch-action: none;
  }

  .content {
    position: relative;
    .bet-list,
    .event-list {
      position: relative;
      height: 100%;
      width: 100%;
      margin: 0 auto;
      padding: 0;
      border-radius: 0;
    }

    .width-container {
      min-height: 100%;
    }
  }

  .centered-message-betting {
    position: relative;
    text-align: center;
    margin: 40vh 10px 55vh;
    transform: translateY(-50%);
  }
`;

export const MobileStyle = `
  * {
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    -ms-box-sizing: border-box;
    -o-box-sizing: border-box;
    box-sizing: border-box;
  }

  html,
  body {
    position: relative;
    -ms-text-size-adjust: none;
    -webkit-text-size-adjust: none;
    height: 100%;
    width: 100%;
    overflow: hidden;
  }

  body {
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);
    font-size: 17px;
    line-height: 21px;
    color: #000;
    background-color: #000;
    -webkit-user-select: none;
  }

  a {
    color: #b5121b;
    text-decoration: none;
    -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

    &:active {
      color: darken(#b5121b, 10%);
    }
  }

  .pull-left {
    float: left;
  }
  .pull-right {
    float: right;
  }
  .clearfix {
    &:before,
    &:after {
      content: ' '; // 1
      display: table; // 2
    }
    &:after {
      clear: both;
    }
  }

  button {
    background: transparent;
    border: 0;

    &:focus {
      outline: none;
    }
  }
  #app, #winabet-app-root {
    background: black;
    position: relative;
    height: 100%;

    width: 100%;
    width: calc(100% - (constant(safe-area-inset-left)+ constant(safe-area-inset-right)));
    width: calc(100% - (env(safe-area-inset-left)+ env(safe-area-inset-right)));

    overflow-x: hidden;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    padding: ${NAVBAR_BASE_HEIGHT}em 0 ${TABBAR_BASE_HEIGHT}em 0;
    padding: calc(${NAVBAR_BASE_HEIGHT}em + constant(safe-area-inset-top)) constant(safe-area-inset-right)
      calc(${TABBAR_BASE_HEIGHT}em + constant(safe-area-inset-bottom)) constant(safe-area-inset-left);
    padding: calc(${NAVBAR_BASE_HEIGHT}em + env(safe-area-inset-top)) env(safe-area-inset-right) calc(${TABBAR_BASE_HEIGHT}em + env(safe-area-inset-bottom))
      env(safe-area-inset-left);
  }

  ::-webkit-scrollbar {
    display: none;
  }
`;
